import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

type ValidateHandleRequest = {
  handle: string;
  user_id?: string;
};

type ValidateHandleResponse = {
  available: boolean;
  message?: string;
};

export async function validateMemberHandle(handle: string, userId?: string) {
  const url = '/web/studio/users/validate-handle';

  /* eslint-disable camelcase */
  const body: ValidateHandleRequest = { handle };
  if (userId) {
    body.user_id = userId;
  }
  /* eslint-enable camelcase */

  const response = await api.executePostRequest<ObjectResponse<ValidateHandleResponse>>(url, body);

  return response.data;
}
